/* eslint-disable vue/no-duplicate-attributes */
<template>
    <div class="page">
        <div class="box">
            <div class="statementBox">
                <div class="statement" v-html="disclaimer"></div>
                <div class="checkboxBox" @click="changeCheckStatement()">
                    <span
                        class="checkbox-statement"
                        :class="{ active: checkedStatement }"
                    ></span>
                    <span>我同意以上声明条款</span>
                </div>
            </div>
            <div
                class="productBox"
                :class="[
                    showProductBox ? 'active' : '',
                    goodsCode == 'STUDY_ZUHE' ? 'zuhe' : '',
                ]"
            >
                <div class="header" v-for="item in studyList" :key="item.id">
                    <div class="left">
                        <div
                            class="imgBox"
                            :style="{
                                background:
                                    'url(' +
                                    item.adImg +
                                    ') no-repeat top center/100% 100%',
                            }"
                        ></div>
                        <!-- <img src="~@/assets/6.png" alt="" /> -->
                    </div>
                    <div class="right">
                        <div class="name">{{ item.title }}</div>
                        <div
                            class="priceBox"
                            v-if="goodsCode == 'STUDY' || 'STUDY_EPISODE'"
                        >
                            <span class="unit">￥</span>
                            <span
                                >{{ item.price }}
                                <span v-if="item.num"
                                    >x{{ item.num }}</span
                                ></span
                            >
                        </div>
                        <hr />
                        <van-radio-group
                            v-if="item.specs && item.specs.length > 0"
                            class="radioBox"
                            v-model="priceRadio[item.id]"
                        >
                            <van-radio
                                :name="spec.id"
                                v-for="spec in item.specs"
                                :key="spec.id"
                                @click="changeRadio(spec.id, item.id)"
                            >
                                <div>{{ spec.unit }}</div>
                                <div class="originalPrice">
                                    ￥{{ spec.originalPrice }}
                                </div>
                                <div class="priceBox">
                                    <span class="unit">￥</span>
                                    <span>{{ spec.price }}</span>
                                </div>
                            </van-radio>
                        </van-radio-group>
                    </div>
                </div>
                <div v-if="goodsCode == 'STUDY_ZUHE'" class="zuhe-price">
                    组合优惠价：￥{{ originalPrice }}
                </div>
                <!-- <div class="footer" v-if="couponList.length > 0">
                    <div class="left">
                        <img
                            class="youhuiquanLogo"
                            src="~@/assets/youhuiquan-logo.png"
                            alt=""
                        />
                        <span>优惠券/红包</span>
                        <span class="mark" @click="showCouponList()">
                            已选推荐优惠
                        </span>
                    </div>
                    <div class="right">
                        <span>-</span>
                        <span>￥</span>
                        <span>{{
                            useCoupon.manjianConfig &&
                                useCoupon.manjianConfig.jian
                        }}</span>
                    </div>
                </div> -->
            </div>

            <div v-if="!isMember" class="noVip-box">
                <div class="title">
                    可用优惠
                </div>
                <div class="quan-box" v-if="couponList.length > 0">
                    <div class="sub-title">
                        <div class="left">
                            <img src="~@/assets/pay-quan.png" alt="" />
                            <b>优惠券</b>
                            <span class="mark" v-if="maxYouhuiType == 'STUDENT'"
                                >已使用最佳优惠</span
                            >
                        </div>
                        <div class="right" v-if="useCoupon.length > 0">
                            -￥{{ useCouponYouhui }}
                        </div>
                    </div>
                    <div class="list">
                        <div
                            class="card"
                            :class="[
                                selQuanList.includes(item.id) ? 'active' : '',
                            ]"
                            v-for="item of couponList"
                            :key="item.id"
                            @click="checkQuan('COUPON', item)"
                        >
                            <div class="card-box">
                                <div class="left">
                                    <div>
                                        ￥<span class="num">{{
                                            item.youhuiType == "XIANJIN"
                                                ? item.xianjin
                                                : item.manjianConfig.jian
                                        }}</span>
                                    </div>
                                    <div>
                                        {{
                                            item.youhuiType == "XIANJIN"
                                                ? "无金额门槛"
                                                : `满${item.manjianConfig.man}可用`
                                        }}
                                    </div>
                                </div>
                                <div class="line-box">
                                    <div class="line"></div>
                                </div>
                                <div class="right">
                                    <div class="quan-name-box">
                                        <div>{{ item.title }}</div>
                                        <div
                                            class="time"
                                            :class="{
                                                hide:
                                                    !item.useEnd ||
                                                    item.useEnd <= 0,
                                            }"
                                        >
                                            有效期至{{ item.useEnd }}
                                        </div>
                                    </div>
                                    <div>
                                        <span
                                            class="checkbox"
                                            :class="[
                                                selQuanList.includes(item.id)
                                                    ? 'active'
                                                    : '',
                                            ]"
                                        ></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="studentBox">
                    <div class="sub-title">
                        <div class="left" @click="showStudentIntroPopup">
                            <img src="~@/assets/pay-vip.png" alt="" />
                            <b>学员优享</b>
                            <img
                                class="help-logo"
                                src="~@/assets/vip-help.png"
                                alt=""
                            />
                        </div>
                    </div>
                    <div class="bottom">
                        <div class="contentBox" @click="changeBuyMember()">
                            <div class="intro">
                                成为学员，一年内购买课程立享
                                <span class="discount">
                                    {{ student.discount }}折
                                </span>
                                优惠
                            </div>
                            <div class="priceBox">
                                <span class="origin-price">
                                    <span>￥</span>
                                    <span>{{ student.originalPrice }}元</span>
                                </span>
                                <span class="sale-price">
                                    <span>￥</span>
                                    <span>{{ student.price }}元/年</span>
                                </span>
                                <span
                                    class="checkbox"
                                    :class="{ active: buyMember }"
                                ></span>
                            </div>
                        </div>
                        <div class="line"></div>
                        <input
                            v-iosInput
                            class="phone"
                            type="tel"
                            v-model="phone"
                            placeholder="输入手机号"
                        />
                    </div>
                </div>
            </div>
            <div
                class="vip-box"
                v-if="isMember && (!closeStudentSale || couponList.length > 0)"
            >
                <div class="title">
                    可用优惠<span>{{
                        couponList.length > 0 ? "优惠券与学员优享不可叠加" : ""
                    }}</span>
                </div>
                <div
                    class="item-checkbox"
                    :class="[selYouhuiType === 'STUDENT' ? 'active' : '']"
                    v-if="!closeStudentSale"
                >
                    <div class="item-box">
                        <div class="b-r-c">
                            <img src="~@/assets/order-checked.png" alt="" />
                        </div>
                        <div class="sub-title">
                            <div class="left" @click="showStudentIntroPopup">
                                <img src="~@/assets/pay-vip.png" alt="" />
                                <b>学员优享</b>
                                <img
                                    class="help-logo"
                                    src="~@/assets/vip-help.png"
                                    alt=""
                                />
                                <span
                                    class="mark"
                                    v-if="maxYouhuiType === 'STUDENT'"
                                    >最佳优惠</span
                                >
                            </div>
                            <div class="right">-￥{{ maxStudentYouhui }}</div>
                        </div>

                        <div
                            class="card"
                            :class="[
                                selYouhuiType === 'STUDENT' ? 'active' : '',
                            ]"
                            @click="checkQuan('STUDENT', student)"
                        >
                            <div class="card-box">
                                <div class="left">
                                    <div>
                                        <span class="num">{{
                                            student.discount
                                        }}</span
                                        >折
                                    </div>
                                </div>
                                <div class="line-box">
                                    <div class="line"></div>
                                </div>
                                <div class="right">
                                    <div class="quan-name-box">
                                        <div>学员优享</div>
                                        <div>
                                            本单享受{{ student.discount }}折优惠
                                        </div>
                                    </div>
                                    <div>
                                        <!-- <span class="checkbox active"></span> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="item-checkbox"
                    v-if="couponList.length > 0"
                    :class="[selYouhuiType === 'COUPON' ? 'active' : '']"
                >
                    <div class="item-box">
                        <div class="b-r-c">
                            <img src="~@/assets/order-checked.png" alt="" />
                        </div>
                        <div class="sub-title">
                            <div class="left">
                                <img src="~@/assets/pay-quan.png" alt="" />
                                <b>优惠券</b>
                                <span
                                    class="mark"
                                    v-if="maxYouhuiType == 'COUPON'"
                                    >最佳优惠</span
                                >
                            </div>
                            <div class="right" v-if="useCoupon.length > 0">
                                -￥{{ useCouponYouhui }}
                            </div>
                        </div>
                        <div class="list">
                            <div
                                class="card"
                                :class="[
                                    selQuanList.includes(item.id)
                                        ? 'active'
                                        : '',
                                ]"
                                v-for="item of couponList"
                                :key="item.id"
                                @click="checkQuan('COUPON', item)"
                            >
                                <div class="card-box">
                                    <div class="left">
                                        <div>
                                            ￥<span class="num">{{
                                                item.youhuiType == "XIANJIN"
                                                    ? item.xianjin
                                                    : item.manjianConfig.jian
                                            }}</span>
                                        </div>
                                        <div>
                                            {{
                                                item.youhuiType == "XIANJIN"
                                                    ? "无金额门槛"
                                                    : `满${item.manjianConfig.man}可用`
                                            }}
                                        </div>
                                    </div>
                                    <div class="line-box">
                                        <div class="line"></div>
                                    </div>
                                    <div class="right">
                                        <div class="quan-name-box">
                                            <div>{{ item.title }}</div>
                                            <div
                                                class="time"
                                                :class="{
                                                    hide:
                                                        !item.useEnd ||
                                                        item.useEnd <= 0,
                                                }"
                                            >
                                                有效期至{{ item.useEnd }}
                                            </div>
                                        </div>
                                        <div>
                                            <span
                                                class="checkbox"
                                                :class="[
                                                    selQuanList.includes(
                                                        item.id,
                                                    )
                                                        ? 'active'
                                                        : '',
                                                ]"
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div
                class="studentBox"
                v-if="isShowStudentBox && !closeStudentSale"
            >
                <div class="header">
                    <div class="left" @click="showStudentIntroPopup">
                        <img
                            class="studentLogo"
                            src="~@/assets/student-logo.png"
                            alt=""
                        />
                        <span>学员优享</span>
                        <img
                            class="help-logo"
                            src="~@/assets/help-logo.png"
                            alt=""
                        />
                    </div>
                    <div class="right">
                        {{
                            isMember
                                ? "本单享" + student.discount + "折优惠"
                                : ""
                        }}
                    </div>
                </div>
                <div class="bottom" v-if="!isMember">
                    <div class="contentBox" @click="changeBuyMember()">
                        <div class="intro">
                            成为学员，一年内购买课程立享
                            <span class="discount">
                                {{ student.discount }}折
                            </span>
                            优惠
                        </div>
                        <div class="priceBox">
                            <span class="origin-price">
                                <span>￥</span>
                                <span>{{ student.originalPrice }}元</span>
                            </span>
                            <span class="sale-price">
                                <span>￥</span>
                                <span>{{ student.price }}元/年</span>
                            </span>
                            <span
                                class="checkbox"
                                :class="{ active: buyMember }"
                            ></span>
                        </div>
                    </div>
                    <div class="line"></div>
                    <input
                        v-iosInput
                        class="phone"
                        type="tel"
                        v-model="phone"
                        placeholder="输入手机号"
                    />
                </div>
                <div v-else class="isMember">
                    <span>-</span>
                    <span>￥</span>
                    <span>{{ studentYouhui }}</span>
                </div>
            </div> -->

            <div class="payTypeBox" :class="{ actve: showPayTypeBox }">
                <div class="title">支付方式</div>
                <div class="line"></div>
                <div class="item" @click="changePayType('WX')">
                    <div class="left">
                        <img
                            class="wxLogo"
                            src="~@/assets/wx-logo.png"
                            alt=""
                        />
                        <span class="name">微信支付</span>
                    </div>
                    <span
                        class="checkbox"
                        :class="[payType == 'WX' ? 'active' : '']"
                    ></span>
                </div>
                <div class="item" @click="changePayType('GOLDPAY')">
                    <div class="left">
                        <img
                            class="niubiLogo"
                            src="~@/assets/niubi-logo.png"
                            alt=""
                        />
                        <div class="name">
                            <div>牛币支付</div>
                            <div class="chongzhiBox" v-if="!ifNiubiEnough">
                                当前您的牛币不足，可前往
                                <span
                                    class="chongzhiBtn"
                                    @click="showChongzhi()"
                                >
                                    充值
                                </span>
                            </div>
                        </div>
                    </div>
                    <span
                        class="checkbox"
                        :class="[payType == 'GOLDPAY' ? 'active' : '']"
                    ></span>
                </div>
            </div>
        </div>
        <div class="submitBox">
            <div class="all-price">
                <div class="left">
                    <span>￥{{ price }}</span>
                    <span class="line"></span>
                    <span>已优惠￥{{ youhuiPrice }}</span>
                </div>
                <img
                    class="helpLogo"
                    :class="[isShowHelpLogo ? 'active' : '']"
                    @click="showPopup()"
                    src="~@/assets/help-logo.png"
                    alt=""
                />
                <img
                    @click="goTityan()"
                    v-if="free.ifFirstTime"
                    class="tiyan"
                    src="~@/assets/tiyan.png"
                    alt=""
                />
            </div>
            <div class="submit" @click="submit()">确认支付</div>
        </div>

        <van-popup v-model="showYouhuiquan" closeable position="bottom">
            <div class="youhuiquan-list">
                <div class="item" v-for="item in couponList" :key="item.id">
                    <div class="header">
                        <div class="left">
                            <div class="title">
                                {{ item.title }}
                            </div>
                            <div class="mark">
                                {{
                                    item.youhuiType == "XIANJIN"
                                        ? "现金券"
                                        : "满减券"
                                }}
                            </div>
                            <div
                                class="time"
                                :class="{
                                    hide: !item.useEnd || item.useEnd <= 0,
                                }"
                            >
                                有效期至{{ item.useEnd }}
                            </div>
                        </div>
                        <div class="right">
                            <span>￥</span>
                            <span>
                                {{
                                    item.youhuiType == "XIANJIN"
                                        ? item.xianjin
                                        : item.manjianConfig.jian
                                }}
                            </span>
                            <div class="ky">
                                {{
                                    item.youhuiType == "XIANJIN"
                                        ? "无金额门槛"
                                        : `满${item.manjianConfig.man}可用`
                                }}
                            </div>
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="footer">
                        <div
                            v-if="!item.expired"
                            class="btn"
                            @click="useCouponById(item.id)"
                        >
                            立即使用
                        </div>
                        <img
                            v-else
                            class="exceedTime"
                            src="~@/assets/exceedTime-logo.png"
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="show" closeable position="bottom">
            <div class="price-detail">
                <div class="sub-title">金额明细</div>
                <div class="list">
                    <div
                        class="item"
                        v-for="item in youhuiList"
                        :key="item.title"
                    >
                        <span>{{ item.title }}</span>
                        <span :class="[item.type == 'JIAN' ? 'jian' : '']">
                            {{ item.price }}
                        </span>
                    </div>
                </div>
            </div>
        </van-popup>
        <van-popup
            v-model="showStudentIntro"
            class="showStudentIntro-popup"
            position="bottom"
            :closeable="false"
        >
            <student-intro
                @changePrice="changePirce($event)"
                @closeStudentIntro="closeStudentIntroPopup()"
                :free="free"
                :index="activeIndex"
            ></student-intro>
        </van-popup>
    </div>
</template>

<script>
    import axios from "axios";
    import studentIntro from "../../components/studentIntro/studentIntro";
    import payService from "../../service/pay.service";
    import rx from "../../_rx";
    import { Toast } from "vant";
    import userCenterService from "../../service/user-center.service";
    export default {
        name: "pay",
        components: {
            "student-intro": studentIntro,
        },
        data() {
            return {
                goodsCode: "",
                id: "",
                priceRadio: {},
                show: false,
                showProductBox: false,
                showPayTypeBox: true,
                isMember: true,
                showYouhuiquan: false,
                couponList: [],
                studyList: [],
                student: {},
                useCoupon: [],
                buyMember: false,
                phone: "",
                youhuiPrice: 0,
                price: 0,
                clonePrice: 0,
                cloneYouhuiPrice: 0,
                youhuiList: [],
                studentYouhui: 0,
                checkedStatement: false,
                ifNiubiEnough: false,
                disclaimer: "",
                originalPrice: 0,
                loading: false,
                payType: "WX",
                showStudentIntro: false,
                specs: [],
                free: {
                    ifFirstTime: false,
                    day: undefined,
                    price: undefined,
                },
                isShowHelpLogo: true,
                activeIndex: 0,
                isShowStudentBox: false,
                closeStudentSale: false,
                maxCouponId: "",
                maxYouhuiType: "",
                selYouhuiType: "",
                maxQuan: "",
                selQuanList: [],
                maxStudentYouhui: 0,
                maxCouponYouhui: 0,
                isMaxCoupon: false,
                useCouponYouhui: 0,
                source: "",
            };
        },
        mounted() {
            this.goodsCode = this.$route.params.goodsCode;

            if (this.goodsCode == "LOT_BUY") {
                this.isShowStudentBox = false;
            } else {
                this.isShowStudentBox = true;
            }
            this.id = this.$route.query.id;

            let tips = this.$route.query.tips;
            if (tips == 1) {
                this.showStudentIntro = true;
            }
            if (this.goodsCode == "STUDENT") {
                this.buyMember = true;
            }
            this.getInfo();

            this.getIfFirstTime();
            this.$nextTick().then(function() {
                let tabbar = document.querySelector("#app .tabbar");
                let bottom = parseInt(getComputedStyle(tabbar).height);
                let submitBox = document.querySelector(".page .submitBox");
                submitBox.style.bottom = bottom + "px";
            });
        },
        methods: {
            checkQuan(type, obj) {
                this.selYouhuiType = type;
                if (type === "COUPON") {
                    let index = this.selQuanList.findIndex(
                        (id) => id == obj.id,
                    );

                    if (index == -1) {
                        this.selQuanList.push(obj.id);
                    } else {
                        this.selQuanList.splice(index, 1);

                        if (this.selQuanList.length == 0) {
                            this.selYouhuiType = "STUDENT";
                        }
                    }

                    // if (this.selQuanList.length === 0) {
                    //     this.selQuanList.push(item);
                    // } else {
                    //     let id = this.selQuanList[0].id;
                    //     this.selQuanList = [];
                    //     if (id !== item.id) {
                    //         this.selQuanList.push(item);
                    //     } else {
                    //         let index = this.selQuanList.findIndex(
                    //             (item) => item.id == id,
                    //         );
                    //         this.selQuanList.splice(index, 1);
                    //         if (this.selQuanList.length == 0) {
                    //             this.selYouhuiType = "STUDENT";
                    //         }
                    //     }
                    // }
                    this.useCoupon =
                        this.selQuanList.length > 0 ? this.selQuanList : [];
                } else {
                    this.selQuanList = [];
                }

                this.getInfo();
            },
            goTityan() {
                this.showStudentIntro = true;
                this.changePirce(1);
                setTimeout(() => {
                    let showStudentIntroPopupEL = document.querySelector(
                        ".showStudentIntro-popup",
                    );
                    showStudentIntroPopupEL.scrollTo(
                        0,
                        showStudentIntroPopupEL.scrollHeight -
                            showStudentIntroPopupEL.clientHeight,
                    );
                }, 300);
            },
            changePirce(index) {
                this.activeIndex = index;
                if (index == 0) {
                    this.youhuiPrice = this.cloneYouhuiPrice;
                    this.price = this.clonePrice;
                    this.isShowHelpLogo = true;
                } else if (index == 1) {
                    this.youhuiPrice = this.free.price;
                    this.price = 0;
                    this.isShowHelpLogo = false;
                }
            },
            getIfFirstTime() {
                payService.ifFirstTime().then((res) => {
                    this.free = res.data;
                });
            },
            changeRadio(specId, studyId) {
                this.priceRadio[studyId] = specId;
                this.priceRadio = Object.assign({}, this.priceRadio);
                this.id = specId;
                this.selYouhuiType = "";
                this.getInfo();
            },
            showPopup() {
                this.show = true;
            },
            showStudentIntroPopup() {
                this.showStudentIntro = true;
            },
            closeStudentIntroPopup() {
                this.showStudentIntro = false;
            },
            getInfo() {
                if (this.source) {
                    this.source.cancel("取消请求");
                }
                // this.selQuanList = [];
                const CancelToken = axios.CancelToken;
                this.source = CancelToken.source();
                payService
                    .getInfo(
                        {
                            goodsId: this.id,
                            couponId: this.useCoupon,
                            buyMember: this.buyMember,
                            phone: this.phone,
                            goodsCode: this.goodsCode,
                            youhuiType: this.selYouhuiType,
                        },
                        this.source.token,
                    )
                    .then((res) => {
                        this.isMember = res.data.student.isMember;
                        this.couponList = res.data.coupon || [];
                        this.studyList = res.data.study;
                        if (this.goodsCode == "STUDENT") {
                            this.showProductBox = false;
                        } else {
                            this.showProductBox = true;
                        }
                        this.student = res.data.student;

                        this.useCoupon = res.data.useCoupon || { id: "" };

                        this.showYouhuiquan = false;
                        this.cloneYouhuiPrice = this.youhuiPrice =
                            res.data.youhuiPrice;
                        this.clonePrice = this.price = res.data.price;
                        this.youhuiList = res.data.youhuiList;
                        this.studentYouhui = res.data.studentYouhui;
                        this.disclaimer = res.data.disclaimer;
                        this.ifNiubiEnough = res.data.ifNiubiEnough;
                        this.originalPrice = res.data.originalPrice;
                        this.studyList.forEach((item) => {
                            if (!this.priceRadio[item.id]) {
                                if (item.specs && item.specs.length > 0) {
                                    this.priceRadio[item.id] =
                                        item.specs && item.specs[0].id;
                                    for (
                                        let i = 0;
                                        i < item.specs.length;
                                        i++
                                    ) {
                                        let spec = item.specs[i];
                                        if (spec.id == this.id) {
                                            this.priceRadio[item.id] = spec.id;
                                            break;
                                        }
                                    }
                                }
                            }
                        });
                        this.closeStudentSale = res.data.closeStudentSale;
                        this.maxCouponId = res.data.maxCouponId;
                        this.maxYouhuiType = res.data.maxYouhuiType;
                        this.maxStudentYouhui = res.data.maxStudentYouhui;
                        this.maxCouponYouhui = res.data.maxCouponYouhui;
                        this.useCouponYouhui = res.data.useCouponYouhui;
                        this.isMaxCoupon = res.data.isMaxCoupon;
                        if (!this.selYouhuiType) {
                            this.selYouhuiType = this.maxYouhuiType;
                        }

                        if (this.useCoupon && this.selYouhuiType == "COUPON") {
                            // if (this.initUseCoupon.length == 0) {
                            this.selQuanList = this.useCoupon;
                            // this.initUseCoupon = this.useCoupon;
                            // }
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            showCouponList() {
                this.showYouhuiquan = true;
            },
            useCouponById(id) {
                this.useCoupon.id = id;

                this.getInfo();
            },
            showChongzhi() {
                rx.emit("showChongzhi");
            },
            changeBuyMember() {
                if (this.goodsCode == "STUDENT") {
                    return;
                }
                this.buyMember = !this.buyMember;
                this.getInfo();
            },
            changeCheckStatement() {
                this.checkedStatement = !this.checkedStatement;
            },
            changePayType(type) {
                if (!this.ifNiubiEnough) {
                    Toast("当前牛币不足");
                    return;
                }
                this.payType = type;
            },
            submit() {
                if (this.activeIndex == 0) {
                    if (this.showStudentIntro) {
                        this.showStudentIntro = false;
                    }
                    if (!this.checkedStatement) {
                        Toast("请勾选免责声明");
                        return;
                    }
                    if (this.buyMember) {
                        if (!this.phone) {
                            Toast("请填写手机号");
                            return;
                        }
                    }
                    if (this.loading) {
                        return;
                    }
                    this.loading = true;
                    userCenterService
                        .createOrder({
                            goodsId: this.id,
                            couponId: this.useCoupon,
                            buyMember: this.buyMember,
                            phone: this.phone,
                            goodsCode: this.goodsCode,
                            payType: this.payType,
                            youhuiType: this.selYouhuiType,
                        })
                        .then((res) => {
                            location.href = `/c/Wxpay/pay?orderId=${res.data.orderId}`;
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                } else if (this.activeIndex == 1) {
                    payService.tiyan().then(() => {
                        Toast("支付成功");
                        this.$router.push("/index");
                    });
                }
            },
        },
    };
</script>

<style lang="scss" scoped src="./pay.scss"></style>
